var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"587cd1b63e3804d4ad993f24712ccb36d3a1ff62"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lacinetek-frontend@codekraft-ka"]={id:"587cd1b63e3804d4ad993f24712ccb36d3a1ff62"};
      